import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var DEFAULT_PREFERENCE_SET_ID = "default";

function buildUpdateParam(param) {
  if (typeof param === "object") {
    return param;
  }

  return {
    subscribed: param
  };
}

class Preferences {
  constructor(instance) {
    _defineProperty(this, "instance", void 0);

    this.instance = instance;
  }

  getAll() {
    var _this = this;

    return _asyncToGenerator(function* () {
      var result = yield _this.instance.client().makeRequest({
        method: "GET",
        url: "/v1/users/".concat(_this.instance.userId, "/preferences")
      });
      return _this.handleResponse(result);
    })();
  }

  get() {
    var _arguments = arguments,
        _this2 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this2.instance.client().makeRequest({
        method: "GET",
        url: "/v1/users/".concat(_this2.instance.userId, "/preferences/").concat(preferenceSetId)
      });
      return _this2.handleResponse(result);
    })();
  }

  set(preferenceSet) {
    var _arguments2 = arguments,
        _this3 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments2.length > 1 && _arguments2[1] !== undefined ? _arguments2[1] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this3.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this3.instance.userId, "/preferences/").concat(preferenceSetId),
        data: preferenceSet
      });
      return _this3.handleResponse(result);
    })();
  }

  setChannelTypes(channelTypePreferences) {
    var _arguments3 = arguments,
        _this4 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments3.length > 1 && _arguments3[1] !== undefined ? _arguments3[1] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this4.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this4.instance.userId, "/preferences/").concat(preferenceSetId, "/channel_types"),
        data: channelTypePreferences
      });
      return _this4.handleResponse(result);
    })();
  }

  setChannelType(channelType, setting) {
    var _arguments4 = arguments,
        _this5 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments4.length > 2 && _arguments4[2] !== undefined ? _arguments4[2] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this5.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this5.instance.userId, "/preferences/").concat(preferenceSetId, "/channel_types/").concat(channelType),
        data: {
          subscribed: setting
        }
      });
      return _this5.handleResponse(result);
    })();
  }

  setWorkflows(workflowPreferences) {
    var _arguments5 = arguments,
        _this6 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments5.length > 1 && _arguments5[1] !== undefined ? _arguments5[1] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this6.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this6.instance.userId, "/preferences/").concat(preferenceSetId, "/workflows"),
        data: workflowPreferences
      });
      return _this6.handleResponse(result);
    })();
  }

  setWorkflow(workflowKey, setting) {
    var _arguments6 = arguments,
        _this7 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments6.length > 2 && _arguments6[2] !== undefined ? _arguments6[2] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var params = buildUpdateParam(setting);
      var result = yield _this7.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this7.instance.userId, "/preferences/").concat(preferenceSetId, "/workflows/").concat(workflowKey),
        data: params
      });
      return _this7.handleResponse(result);
    })();
  }

  setCategories(categoryPreferences) {
    var _arguments7 = arguments,
        _this8 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments7.length > 1 && _arguments7[1] !== undefined ? _arguments7[1] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var result = yield _this8.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this8.instance.userId, "/preferences/").concat(preferenceSetId, "/categories"),
        data: categoryPreferences
      });
      return _this8.handleResponse(result);
    })();
  }

  setCategory(categoryKey, setting) {
    var _arguments8 = arguments,
        _this9 = this;

    return _asyncToGenerator(function* () {
      var options = _arguments8.length > 2 && _arguments8[2] !== undefined ? _arguments8[2] : {};
      var preferenceSetId = options.preferenceSet || DEFAULT_PREFERENCE_SET_ID;
      var params = buildUpdateParam(setting);
      var result = yield _this9.instance.client().makeRequest({
        method: "PUT",
        url: "/v1/users/".concat(_this9.instance.userId, "/preferences/").concat(preferenceSetId, "/categories/").concat(categoryKey),
        data: params
      });
      return _this9.handleResponse(result);
    })();
  }

  handleResponse(response) {
    if (response.statusCode === "error") {
      throw new Error(response.error || response.body);
    }

    return response.body;
  }

}

export default Preferences;
//# sourceMappingURL=index.js.map